export const initialState = {
    loading: false,
    disputesChat: {},
    disputes: [],
    lastDoc: null,
    isEnd: false,
    selectedDispute: null,
}